function UnauthenticatedApp(props) {
    window.location.href = '/account/signin';
    return null;
}

export default UnauthenticatedApp;